import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Grid,
  Modal,
  // Input,
} from '../../../src/components/index';

class ModalStatusIntegracaoGet extends Component {
modalContent = () => (
  <React.Fragment>
    <div className="row">
      <Grid cols="12 12 12 12">
        <div>
          <h3>Concluída</h3>
          <ul>
            <li>A operação de comunicação do Comprev com o GET foi finalizada com sucesso.</li>
          </ul>
          <h3>Indisponibilidade ou falha técnica</h3>
          <ul>
            <li>A operação de comunicação do Comprev com o GET apresentou uma indisponibilidade momentânea ou uma falha técnica.</li>
            <li>A natureza da falha pode exigir atuação da equipe de suporte da aplicação.</li>
            <li>Periodicidade de comunicação em até 10 minutos.</li>
          </ul>
          <h3>Falha de negócio </h3>
          <ul>
            <li>A operação de comunicação do Comprev com o GET apresentou falha de negócio relacionado ao GET.</li>
            <li>Veja o campo <strong>Mensagem Retorno</strong>  para mais informações sobre à crítica de negócio.</li>
            <li>Periodicidade de comunicação é uma vez por dia no primeiro horário da madrugada ou,
              havendo ajuste da crítica de negócio, pode ser reprocessada em até 10 minutos clicando no botão de ação da tabela de pesquisa.
            </li>
          </ul>
          <h3>Pronta para nova execução </h3>
          <ul>
            <li>A operação de comunicação do Comprev com o GET será reprocessada automaticamente pela aplicação.</li>
            <li>Periodicidade de comunicação em até 10 minutos.</li>
          </ul>
        </div>
      </Grid>
    </div>
  </React.Fragment>
)
modalFooter = () => (
  <React.Fragment>
    <div className="right">
      <Button
        title="Fechar"
        onClick={this.handleCloseStatusIntegracaoGet}
        hint="Fechar"
      />
    </div>
  </React.Fragment>
)

  handleCloseStatusIntegracaoGet = () => {
    this.setState(this.props.handleModal('showStatusRetornoGetModal'));
  }
  render() {
    return (
      <Modal
        {...this.props}
        conteudofooter={this.modalFooter()}
        conteudomodal={this.modalContent()}
        onHide={this.handleCloseStatusIntegracaoGet}
        size="lg"
        showModal={this.props.showModal}
        title="Legenda para o Status da Operação"
      />
    );
  }
}

ModalStatusIntegracaoGet.propTypes = {
  showModal: PropTypes.func,
  handleModal: PropTypes.func,
  estadoFormulario: PropTypes.objectOf(PropTypes.object).isRequired,
  auth: PropTypes.objectOf(PropTypes.object).isRequired,
}.isRequired;

export default ModalStatusIntegracaoGet;



// WEBPACK FOOTER //
// ./src/pages/consultas/ModalStatusIntegracaoGet.jsx